<template>
  <div class="channel">
    <div class="channel__header">
      <div :class="['channel__header__desktop', desktopbanner]">
        <div class="channel__header__desktop__text">
          <h1 class="xlarge-title">{{ title  | capitalizing}}</h1>
          <p class="regular-font">{{ subtitle }}</p>
          <a v-if="!isDigital" :href="'/contact-us?subject=' + name"><button type="button" class="btn-regular primary btn-contact-us">Buat Iklan</button></a>
          <a v-else :href="'/digital-advertising'"><button type="button" class="btn-regular primary btn-contact-us">Buat Iklan</button></a>
        </div>
      </div>
      <div class="channel__header__mobile">
        <div class="channel__header__mobile__banner">
          <img :src="mobilebanner">
        </div>
        <div class="channel__header__mobile__text">
          <h1 class="xlarge-title">{{ title  | capitalizing}}</h1>
          <p class="regular-font">{{ subtitle }}</p>
        </div>
      </div>
    </div>
    <div class="channel__content">
      <div class="channel__content--left">
        <img class="channel__content__banner" :src="getContentBanner()">
      </div>
      <div class="channel__content--right">
        <span v-html="description"></span>
      </div>
    </div>
    <div class="channel__footer">
      <div class="channel__footer__text">
        <p class="medium-title first-capital">discuss your next advertising spot opportunity</p>
      </div>
      <div class="channel__footer__button">
        <a :href="'/contact-us?subject=' + name"><button type="button" class="btn-regular primary btn-contact-us">Start a Conversation</button></a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-channel',
  components: {

  },
  props: {

  },
  data() {
    return {
      items: [
        {
          "name": "billboard",
          "title": "Billboard Advertising",
          "subtitle": "Bawa iklan Anda dimana audience Anda berada.",
          "desktopbanner": "billboard-banner-desktop",
          "desktopcontentbanner": "/img/channel/billboard-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/billboard-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/billboard-content-banner-mobile.jpg",
          "description": "Jangkau audience Anda 24/7 dengan billboard advertising. Billboard selalu bisa ditemukan di setiap titik perjalanan sehari-hari mereka, mulai dari perjalanan kendaraan mereka sampai di titik penjualan. ADX bisa membantu Anda menarik perhatian masyarakat melalui pilihan billboard di berbagai lokasi strategis."
        },
        {
          "name": "cinema",
          "title": "Cinema Advertising",
          "subtitle": "Jadikan iklan lebih berkesan lewat layar lebar.",
          "desktopbanner": "cinema-banner-desktop",
          "desktopcontentbanner": "/img/channel/cinema-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/cinema-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/cinema-content-banner-mobile.jpg",
          "description": "Visual menawan, cerita menarik, tapi masih diabaikan? Angkat iklan Anda ke layar lebar! Suasana santai bioskop mendorong penonton untuk memberi perhatian penuh untuk iklan Anda. Dengan layar besar dan sistem audio berkualitas, Anda berkesempatan untuk menampilkan iklan Anda layaknya sebuah film dan tinggalkan kesan mendalam kepada para penonton."
        },
        {
          "name": "digital",
          "title": "Digital Advertising",
          "subtitle": "Iklankan bisnis Anda kepada orang yang tepat untuk produk Anda.",
          "desktopbanner": "digital-banner-desktop",
          "desktopcontentbanner": "/img/channel/digital-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/digital-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/digital-content-banner-mobile.jpg",
          "description": "Advertising bukan hal mudah, dan kami ingin Anda sukses. Berikut ini beberapa opsi iklan digital untuk semua anggaran dan level keahlian, Anda dapat memulainya dari skala kecil atau langsung besar, dan Anda bisa selalu memantau kinerja iklan Anda dan melakukan perubahan kapan pun.<br /><br />Jangkau lebih banyak pelanggan untuk mendapatkan pengunjung baru untuk situs Anda, meningkatkan penjualan online, jumlah traffic di toko Anda, digital Advertising dapat membantu Anda. Beriklan secara lokal atau global, targetkan iklan Anda untuk pelanggan di negara, wilayah, atau kota tertentu atau dalam jarak tertentu dari bisnis atau toko Anda.<br /><br />Tampilkan iklan Anda di seluruh penjuru digital mulai dari Google Ads, Instagram Ads, YouTube Ads, Facebook Ads, dan SMS Blast."
        },
        {
          "name": "experience",
          "title": "Experience Branding",
          "subtitle": "Buat ide branding Anda menjadi kenyataan.",
          "desktopbanner": "experience-banner-desktop",
          "desktopcontentbanner": "/img/channel/experience-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/experience-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/experience-content-banner-mobile.jpg",
          "description": "Ketika setiap brand berjuang untuk mendapatkan perhatian, stand out dengan branding experience ADX. Dari buku menu di restoran hingga stiker cermin di salon kecantikan, kami membuat ide branding Anda menjadi kenyataan."
        },
        {
          "name": "inflight",
          "title": "InFlight Advertising",
          "subtitle": "Bawa iklan Anda keliling dunia dengan brand premium Indonesia.",
          "desktopbanner": "inflight-banner-desktop",
          "desktopcontentbanner": "/img/channel/inflight-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/inflight-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/inflight-content-banner-mobile.jpg",
          "description": "Penerbangan adalah waktu luang. Kapan lagi saat yang tepat untuk menayangkan iklan Anda? Mereka yang berada di udara lebih fokus saat menonton sebuah iklan dan bisa menangkap pesan sebuah iklan dengan lebih baik. Bekerja sama dengan airline terbaik Indonesia, ADX membuka jalan bagi bisnis Anda untuk memperkenalkan diri kepada traveller dari seluruh dunia. Pasang iklan Anda di Garuda Indonesia dan tingkatkan profil brand dan reputasi bisnis Anda bersama mereka."
        },
        {
          "name": "rideshare",
          "title": "Rideshare Advertising",
          "subtitle": "Beriklan kepada mereka yang bosan/terjebak di kemacetan.",
          "desktopbanner": "rideshare-banner-desktop",
          "desktopcontentbanner": "/img/channel/rideshare-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/rideshare-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/rideshare-content-banner-mobile.jpg",
          "description": "Masyarakat Jakarta rata-rata menghabiskan 68 menit sehari di perjalanan. Kenapa tidak buat perjalanan mereka berasa lebih cepat dengan iklan Anda? Hibur para penumpang yang bosan di kemacetan Jakarta dengan iklan Anda. Dengan ADX, Anda berkesempatan untuk menayangkan iklan Anda dengan visual dan audio yang jernih di hadapan para penonton yang sempurna - the active and influential business players."
        },
        {
          "name": "videotron",
          "title": "Videotron Advertising",
          "subtitle": "Jangkau ribuan orang dengan layar digital di lokasi strategis ibu kota",
          "desktopbanner": "videotron-banner-desktop",
          "desktopcontentbanner": "/img/channel/videotron-content-banner-desktop.jpg",
          "mobilebanner": "/img/channel/videotron-banner-mobile.jpg",
          "mobilecontentbanner": "/img/channel/videotron-content-banner-mobile.jpg",
          "description": "Tidak ada istilah “terlalu kreatif” saat Anda berbicara tentang videotron advertising. Dengan layar digital ADX yang terletak di lokasi strategis ibu kota, Anda bisa dengan bebas berkreasi membuat konten iklan yang out of the box, eye-catching, dan mudah diingat."
        }
      ],
      name: '',
      title: '',
      subtitle: '',
      desktopbanner: '',
      desktopcontentbanner: '',
      mobilebanner: '',
      mobilecontentbanner: '',
      description: '',
      isDigital: false,
      isMobile: document.documentElement.clientWidth <= 768 ? true : false
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadData() {
      let isNotFound = true
      this.name = this.$route.params.name
      for (var i=0; i < this.items.length; i++) {
        var item = this.items[i]
        if (item.name == this.name) {
          this.title = item.title
          this.subtitle = item.subtitle
          this.desktopbanner = item.desktopbanner
          this.desktopcontentbanner = item.desktopcontentbanner
          this.mobilebanner = item.mobilebanner
          this.mobilecontentbanner = item.mobilecontentbanner
          this.description = item.description
          isNotFound = false
          if (this.name == 'digital') this.isDigital = true 
        }
      }

      if (isNotFound) {
        this.$router.replace({ name: '404' })
      }
    },
    getContentBanner() {
      return this.isMobile ? this.mobilecontentbanner: this.desktopcontentbanner
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>